import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["simple", "responsive"],
      _excluded2 = ["simple", "responsive"],
      _excluded3 = ["simple"];
import { memoizeDeep, safeMerge } from "../../common/utilities";
const setBox = memoizeDeep(function (_ref) {
  let {
    box,
    display,
    block,
    fullWidth,
    responsive,
    leftIcon,
    rightIcon
  } = _ref;

  /**
   * Adding box wrapping classes (mostly display).
   */
  return safeMerge(typeof box === "function" ? box({
    display,
    block,
    fullWidth,
    responsive,
    leftIcon,
    rightIcon
  }) : box);
});
const setRoot = memoizeDeep(function (_ref2) {
  let {
    button,
    kind,
    slim,
    block,
    centerIcon,
    leftIcon,
    rightIcon,
    radius,
    responsive,
    size,
    fullWidth
  } = _ref2;
  let cssRoot = {};
  /**
   * Adding primary, secondary and tertiary styles to the root.
   */

  cssRoot = safeMerge(button.root, button[kind]);
  /**
   * Adding the "size" styles, but it does not apply to simple.
   * If "slim" is true, use the "medium" size.
   */

  cssRoot = safeMerge(cssRoot, kind !== "simple" ? button.modifiers.size[slim ? "small" : size] : null);
  /**
   * Adding the "block" styles.
   */

  cssRoot = safeMerge(cssRoot, block ? button.modifiers.block : null);
  /**
   * Adding the hidden "fullWidth" styles.
   */

  cssRoot = safeMerge(cssRoot, fullWidth ? button.modifiers.fullWidth : null);
  /**
   * Adding the "responsive" styles, but it does not apply to icons.
   * For responsive AND icons, see the icons definitions.
   */

  if (responsive && !centerIcon && !leftIcon && !rightIcon) {
    cssRoot = safeMerge(cssRoot, button.modifiers.responsive);
  }
  /**
   * Adding the hidden "radius" styles.
   */


  cssRoot = safeMerge(cssRoot, typeof radius === "number" ? button.modifiers.radius.number(radius) : button.modifiers.radius[radius]);
  /**
   * Addingstyles to the root when an left icon is used.
   */

  if (leftIcon) {
    const _button$modifiers$ico = button.modifiers.icon.left,
          {
      simple: simpleLeftIconStyles,
      responsive: responsiveLeftIconStyles
    } = _button$modifiers$ico,
          commonLeftIconStyles = _objectWithoutProperties(_button$modifiers$ico, _excluded);

    cssRoot = safeMerge(cssRoot, commonLeftIconStyles);

    if (kind === "simple") {
      cssRoot = safeMerge(cssRoot, simpleLeftIconStyles);
    }

    if (responsive) {
      cssRoot = safeMerge(cssRoot, responsiveLeftIconStyles);
    }
  }
  /**
   * Addingstyles to the root when an right icon is used.
   */


  if (rightIcon) {
    const _button$modifiers$ico2 = button.modifiers.icon.right,
          {
      simple: simpleRightIconStyles,
      responsive: responsiveRightIconStyles
    } = _button$modifiers$ico2,
          commonRightIconStyles = _objectWithoutProperties(_button$modifiers$ico2, _excluded2);

    cssRoot = safeMerge(cssRoot, commonRightIconStyles);

    if (kind === "simple") {
      cssRoot = safeMerge(cssRoot, simpleRightIconStyles);
    }

    if (responsive) {
      cssRoot = safeMerge(cssRoot, responsiveRightIconStyles);
    }
  }
  /**
   * Addingstyles to the root when an center icon is used.
   */


  if (centerIcon) {
    const _button$modifiers$ico3 = button.modifiers.icon.center,
          {
      simple: simpleCenterIconStyles
    } = _button$modifiers$ico3,
          commonCenterIconStyles = _objectWithoutProperties(_button$modifiers$ico3, _excluded3);

    cssRoot = safeMerge(cssRoot, commonCenterIconStyles);

    if (kind === "simple") {
      cssRoot = safeMerge(cssRoot, simpleCenterIconStyles);
    }
  }

  return cssRoot;
});
export default function (_ref3) {
  var _theme$components;

  let {
    theme,
    kind,
    slim,
    block,
    centerIcon,
    leftIcon,
    rightIcon,
    radius,
    display,
    responsive,
    size,
    fullWidth
  } = _ref3;
  let cssRoot = {},
      cssLabel = {},
      cssBox = {};
  const button = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.button;

  if (button) {
    var _button$modifiers;

    cssBox = setBox({
      box: button.box,
      display,
      block,
      fullWidth,
      responsive,
      leftIcon,
      rightIcon
    });
    cssRoot = setRoot({
      button,
      kind,
      slim,
      block,
      fullWidth,
      centerIcon,
      leftIcon,
      rightIcon,
      radius,
      responsive,
      size
    });
    cssLabel = button === null || button === void 0 ? void 0 : (_button$modifiers = button.modifiers) === null || _button$modifiers === void 0 ? void 0 : _button$modifiers.smoothBoldLabelTransition;
  }

  return {
    cssBox,
    cssRoot,
    cssLabel
  };
}